import { Box, Link } from "@mui/material";

const ResearchTile = ({ label, href, iconClass, bg, color }) => (
  <Link
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    underline="none"
    className="edsimsV2-research-tile"
  >
    <Box
      className="edsimsV2-research-tile-icon"
      style={{
        "--edsimsV2-research-icon-bg": bg,
        "--edsimsV2-research-icon-color": color,
      }}
      aria-hidden="true"
    >
      <i className={iconClass} aria-hidden="true" />
    </Box>
    <p
      className={[
        "edsimsV2-research-tile-label",
        label === "White Papers" ? "edsimsV2-research-tile-label--tight" : "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {label}
    </p>
    <span className="edsimsV2-sr-only">(opens in a new tab)</span>
  </Link>
);

export default ResearchTile;
